export const initialDictionariesErrorStyles = {
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    py: { xs: 6, sm: 10 },
    textAlign: 'center',
  },
};
